module.exports = __webpack_public_path__ + "static/avatar-6a14f67ceb652fb23669ddf7a92145c2.gif";